import { FormEvent, useState } from 'react';
import { login } from '../lib/api';

interface Props {
  onAuthed: () => void;
}

export default function Login({ onAuthed }: Props) {
  const [pw, setPw] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    const result = await login(pw);
    setBusy(false);
    if (result.ok) onAuthed();
    else setErr(result.error || 'incorrect password');
  }

  return (
    <main style={{
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      padding: '2rem',
    }}>
      <div className="bracketed" style={{ width: 'min(420px, 100%)', padding: '3rem 2.5rem', background: 'var(--background)' }}>
        <div className="eyebrow" style={{ marginBottom: '1.5rem' }}>
          <span className="dot dot-pulse" />tv.compoundrx — restricted access
        </div>

        <h1 className="headline" style={{ fontSize: 'clamp(28px, 4vw, 40px)', marginBottom: '0.5rem' }}>
          Live floor<br/>operations feed.
        </h1>

        <p className="mono" style={{ fontSize: 13, color: 'var(--muted)', marginBottom: '2rem', lineHeight: 1.6 }}>
          Authorized viewers only. Footage is privacy-filtered and time-bounded.
          No PHI cameras are surfaced here.
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <label className="eyebrow" htmlFor="pw">Access key</label>
          <input
            id="pw"
            type="password"
            autoComplete="current-password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            disabled={busy}
            autoFocus
          />
          {err && <div className="mono" style={{ fontSize: 11, color: 'var(--orange)' }}>▸ {err}</div>}
          <button type="submit" className="btn-primary" disabled={busy || !pw}>
            {busy ? '…verifying' : 'enter'}
          </button>
        </form>

        <div className="mono" style={{ marginTop: '2.5rem', fontSize: 10, color: 'var(--muted)', letterSpacing: '0.1em' }}>
          ■ session is logged · 24h auto-expire
        </div>
      </div>
    </main>
  );
}
